import { render, staticRenderFns } from "./MediaLibraryFile.vue?vue&type=template&id=3e3d7efa&scoped=true&"
import script from "./MediaLibraryFile.vue?vue&type=script&lang=js&"
export * from "./MediaLibraryFile.vue?vue&type=script&lang=js&"
import style0 from "../Style/media-library-file.scss?vue&type=style&index=0&id=3e3d7efa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e3d7efa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Projects\\Werk\\MarketingDbNEW\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e3d7efa')) {
      api.createRecord('3e3d7efa', component.options)
    } else {
      api.reload('3e3d7efa', component.options)
    }
    module.hot.accept("./MediaLibraryFile.vue?vue&type=template&id=3e3d7efa&scoped=true&", function () {
      api.rerender('3e3d7efa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/MediaLibrary/Components/MediaLibraryFile.vue"
export default component.exports